import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { useColors } from "../../hooks/colors/useColors";
import { Container } from "../../components/UI/container/Container";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { isPhone } from "../../constants/env";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "privacy"])),
      // Will be passed to the page component as props
    },
  };
}

function ContactPage() {
  const { colors } = useColors();
  const { t } = useTranslation("privacy");

  return (
    <Fragment>
      <MyHead title={t("privacy:policy")} description={t("privacy:policy")} />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color={colors.white}
          className="text-center"
        >
          {t("privacy:policy")}
        </MyH1>
      </PageHeader>
      <div>
        <Container noHeight>
          <div
            // @ts-ignore
            dangerouslySetInnerHTML={{ __html: t("privacy:content") }}
          />
        </Container>
      </div>
      <Footer isVisible />
    </Fragment>
  );
}

export default ContactPage;
